import {EntityService} from '../../../../service/EntityService';

export class RoleService extends EntityService {

  static entity = 'api/app/m-identity-role';

  static currentTenant(): Promise<any>{
    return this.axios.get(`${this.entity}/current`).then(res => res.data);
  }
}
